import { PictureOutlined } from '@ant-design/icons';
import { useWidgetVisibility } from '@framework/engine/schema/widgets/hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { getWidgetProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { Spin } from 'antd';
import styled from 'styled-components';
import { type IImageWidget } from './IImageWidget.ts';
import { useImagePreviewUrl } from './useImagePreviewUrl.ts';

const StyledImageWrapper = styled.div<{ $alignment: string }>`
  display: flex;
  justify-content: ${({ $alignment }) => {
    if ($alignment === 'center') return 'center';
    if ($alignment === 'right') return 'flex-end';
    return 'flex-start';
  }};
  margin-bottom: 6px;
`;
const StyledImagePlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  min-width: 80px;
  min-height: 60px;
  background-color: #f5f5f5;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  color: #8c8c8c;
  font-size: 12px;
`;
const StyledPreviewImage = styled.img<{
  $maxWidth?: number | null;
  $maxHeight?: number | null;
}>`
  max-width: ${({ $maxWidth }) => ($maxWidth != null ? `${$maxWidth}px` : '100%')};
  max-height: ${({ $maxHeight }) => ($maxHeight != null ? `${$maxHeight}px` : 'auto')};
  border: 1px solid #d9d9d9;
  border-radius: 4px;
`;

export interface IImageWidgetCanvasComponentProps
  extends IWidgetComponentProps<IImageWidget> {}

/**
 * Componente canvas/anteprima del widget Immagine: se è presente
 * un'immagine la mostra rispettando allineamento e dimensioni massime,
 * altrimenti mostra il placeholder dell'engine.
 */
export function ImageWidgetComponent(props: IImageWidgetCanvasComponentProps) {
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);
  const { url: previewUrl, isLoading: isPreviewLoading } = useImagePreviewUrl(
    props.widget.imageId,
  );

  if (!visible) return null;

  const { imageId, alignment, maxWidth, maxHeight } = props.widget;

  return (
    <StyledImageWrapper $alignment={alignment ?? 'left'}>
      {imageId == null || isPreviewLoading || previewUrl == null ? (
        <StyledImagePlaceholder>
          {isPreviewLoading ? (
            <Spin />
          ) : (
            <>
              <PictureOutlined style={{ fontSize: 24 }} />
              <span>Nessuna immagine selezionata</span>
            </>
          )}
        </StyledImagePlaceholder>
      ) : (
        <StyledPreviewImage
          $maxWidth={maxWidth}
          $maxHeight={maxHeight}
          src={previewUrl}
          alt=""
        />
      )}
    </StyledImageWrapper>
  );
}
